import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';
import { Portal } from "react-portal";

export default class LightboxGallery extends Component {
	
	constructor(){
		super()
		this.state = {
			active: 0,
			next:1,
			prev: 0,
			open:false,
			opened:false,
		}
		this.handleNext 	= this.handleNext.bind(this);
		this.handlePrev 	= this.handlePrev.bind(this);
		this.handleToggle 	= this.handleToggle.bind(this);
	}
  	
  	componentDidMount() {
	  	this.setState({ prev: this.props.gallery.length - 1 });
  	}
  	
	handleToggle() { 
    	this.setState({ open: !this.state.open, opened: true });
  	};
  	
  	handleNext() { 
    	let active = this.state.active + 1;
    	if (active === this.props.gallery.length) {
	    	active = 0;
    	}
    	let next = this.state.next + 1;
    	if (next === this.props.gallery.length) {
	    	next = 0;
    	}
    	let prev = this.state.prev + 1;
    	if (prev === this.props.gallery.length) {
	    	prev = 0;
    	}
    	this.setState({ active: active, next: next, prev: prev });
  	};
  	
  	handlePrev() { 
    	let active = this.state.active - 1;
    	if (active === -1) {
	    	active = this.props.gallery.length - 1;
    	}
    	let next = this.state.next - 1;
    	if (next === -1) {
	    	next = this.props.gallery.length - 1;
    	}
    	let prev = this.state.prev - 1;
    	if (prev === -1) {
	    	prev = this.props.gallery.length - 1;
    	}
    	this.setState({ active: active, next: next, prev: prev });
  	};
  
  			
	render() {
		
		if (this.state.open) {
			document.documentElement.classList.add('state-reverse-cursor'); 
		} else {
			document.documentElement.classList.remove('state-reverse-cursor');
		}
		
		let gallery = this.props.gallery;
		
		if (gallery) {
			
			const slides = gallery.map((slide,i) =>
				{
					let slideClass = 'c-gallery__slide';
					if (i === this.state.active) {
						slideClass = slideClass + ' state-active';
					}
					return (
						<div className={slideClass} key={i}>
							{slide.srcset && (this.state.active === i || this.state.next === i || this.state.prev === i) &&
								<FadeIn>
									{onload => (
										<img
											alt={''} 
											src={slide.src} 
											srcSet={slide.srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							}
							{!slide.srcset && (this.state.active === i || this.state.next === i || this.state.prev === i) &&
								<FadeIn>
									{onload => (
										<img
											alt={''} 
											src={slide.src} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							}
						</div>
					)
				}
			);
			
			let lbClass = 'c-lightbox';
			if (this.state.open) {
				lbClass = lbClass + ' state-active';
			}

			return (				
				
				<>
					<div className={'c-gallery c-gallery--' + gallery.length}>
						{slides}
						<div className="c-gallery__zoom" onClick={this.handleToggle}></div>
						{slides.length > 1 &&
							<>
								<div className="c-gallery__next" onClick={this.handleNext} onMouseOver={this.handleNextOver} onMouseOut={this.handleNextOut}></div>
								<div className="c-gallery__prev" onClick={this.handlePrev} onMouseOver={this.handlePrevOver} onMouseOut={this.handlePrevOut}></div>
							</>
						}
					</div>
					<Portal>
						<div className={lbClass}>
							<div className="c-header">
					    		<div className="l-content">
					    			<div className="l-grid">
					    				<div className="l-grid__col">
											<h2 className="c-header__logo">
												<Link to={{ pathname: '/' }} className="c-header__logo__inner">Castran
													<svg viewBox="0 0 212 31">
														<path d="m23.82 18.31-1.26 1.56c-1.56 1.89-3.89 2.98-6.34 2.94-4.35 0-7.9-3.26-7.9-7.27s3.54-7.27 7.9-7.27c2.45-0.04 4.79 1.04 6.34 2.94l1.26 1.56 6.59-4.69-1.35-1.67c-3.18-3.8-7.89-5.99-12.84-5.96-8.9 0-16.13 6.77-16.13 15.09s7.24 15.09 16.13 15.09c4.96 0.04 9.67-2.15 12.84-5.97l1.34-1.66-6.58-4.69zm64.97-8.77h8.86v21.09h8.33v-21.09h8.86v-8.33h-26.05v8.33zm-3.63 6.66c-0.87-1.06-1.94-1.94-3.14-2.59-1.15-0.61-2.37-1.07-3.63-1.36-1.21-0.28-2.23-0.49-3.01-0.61-0.18-0.03-0.36-0.06-0.55-0.08-0.16-0.02-0.31-0.05-0.46-0.11-0.74-0.15-1.46-0.37-2.16-0.67-0.74-0.32-0.85-0.71-0.86-0.95v-0.14c0-0.34 0-1.36 2.61-1.52 0.99-0.05 1.98 0.03 2.95 0.25 1.23 0.28 2.39 0.8 3.42 1.54l0.32 0.22 5.21-6.14-0.39-0.27c-1.08-0.75-2.24-1.39-3.45-1.9-1.98-0.84-4.1-1.33-6.25-1.45-0.92-0.05-1.71-0.05-2.38-0.02-1.65 0.08-3.28 0.45-4.8 1.11-1.23 0.54-2.35 1.3-3.3 2.25-0.83 0.85-1.47 1.87-1.88 2.99-0.38 1.04-0.57 2.14-0.54 3.25 0.05 2.24 1.03 4.36 2.69 5.85 1.98 1.72 4.42 2.84 7.02 3.23 0.23 0.07 0.46 0.12 0.7 0.13 0.2 0.02 0.39 0.06 0.58 0.11 1 0.15 1.81 0.3 2.41 0.46 0.46 0.1 0.91 0.26 1.34 0.45 0.21 0.09 0.4 0.23 0.55 0.41 0.08 0.11 0.13 0.25 0.13 0.39-0.01 0.11-0.03 0.23-0.06 0.33-0.07 0.17-0.18 0.31-0.32 0.43-0.72 0.71-2.01 1.04-3.83 0.94-0.44-0.01-0.88-0.06-1.32-0.15-0.53-0.11-1.06-0.28-1.56-0.49-0.57-0.24-1.12-0.54-1.64-0.89-0.57-0.39-1.09-0.84-1.56-1.35l-0.34-0.37-5.22 6.37 0.3 0.28c1.62 1.5 3.53 2.64 5.62 3.36 1.79 0.64 3.66 1 5.55 1.07h0.41c1.14 0.01 2.28-0.09 3.41-0.31 0.92-0.18 1.83-0.45 2.71-0.79 1.32-0.52 2.52-1.29 3.53-2.27 0.93-0.87 1.67-1.93 2.17-3.1 0.48-1.13 0.69-2.35 0.62-3.57-0.08-1.56-0.64-3.08-1.6-4.32zm118.43-14.99v16.12l-11.47-16.13h-9.11v29.42h8.33v-16.07l11.47 16.08h9.12v-29.42h-8.34zm-35.78 0.59h-7.78l-11.5 28.43-0.16 0.4h8.39l1.77-4.41h10.75l1.81 4.41h8.34l-11.55-28.65-0.07-0.18zm-6.13 16.67 2.21-5.52 2.26 5.52h-4.47zm-120.3-16.68-11.67 28.84h8.39l1.76-4.41h10.75l1.81 4.41h8.34l-11.59-28.84h-7.79zm1.66 16.68 2.21-5.52 2.25 5.52h-4.46zm100.63-14.43c-1.75-1.77-4.15-2.77-6.64-2.77h-19.18v29.29h8.29v-10.54h5.55l4.92 10.54h8.83l-5.18-11.12c0.14-0.05 0.28-0.11 0.42-0.17 1.11-0.47 2.12-1.15 2.98-2v0.01c0.85-0.86 1.53-1.87 2-2.98 0.49-1.15 0.74-2.4 0.74-3.65 0.01-1.25-0.25-2.49-0.74-3.63-0.47-1.11-1.15-2.12-1.99-2.98zm-5.93 7.48c-0.23 0.24-0.54 0.37-0.87 0.36h-10.73v-2.47h10.73c0.33-0.01 0.65 0.12 0.87 0.37 0.23 0.22 0.36 0.52 0.36 0.84 0.02 0.34-0.11 0.66-0.36 0.9z" fill="#3C3C3C"/>
													</svg>
												</Link>
											</h2>
											<div className="c-header__buttons">
												<a className="c-header__menu" onClick={this.handleToggle}>
													<div className="c-header__menu__line c-header__menu__top"></div>
													<div className="c-header__menu__line c-header__menu__bottom"></div>
													<div className="c-header__menu__line c-header__menu__middle"></div>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={'c-gallery c-gallery--' + gallery.length}>
								{slides}
								{slides.length > 1 &&
									<>
										<div className="c-gallery__next" onClick={this.handleNext}></div>
										<div className="c-gallery__prev" onClick={this.handlePrev}></div>
									</>
								}
							</div>
						</div>
					</Portal>
				</>					
			);
			
		} else {
			return null;
		}
	}
}